<template>
    <div  style="width: 50% !important;">
        <component :style="getWidth"
                   :is="component"
                   :value="value"
                   :options="options"
                   :type="type"
                   :id="id"
                   @enter="$emit('enter')"
                   @input="$emit('input', $event)"
                   @focus="focusHandler()"
                   @blur="$emit('blur')"
                   @invalid="invalidHandler($event)">
        </component>
        <p v-if="error" class="field-error">{{error}}</p>
        <p v-if="!error && hint" class="field-hint">{{hint}}</p>
    </div>
</template>

<script>
    import SimpleInput from "./SimpleInput";
    import DateField from "./DateField";
    /*
    import SelectField from "./SelectField";
    import TextareaField from "./TextareaField";
    import ResizableTextarea from "./ResizableTextarea";
    import FileField from "./FileField";
    import RadioList from "./RadioList";
    import GroupField from "./GroupField";*/
    import {GROUP, SELECT, DATE, FILE, RADIO_LIST, TEXTAREA} from "../../../constants/common"

    export default {
        name: 'input-field',

        components: {
            /*GroupField,
            RadioList,
            FileField,
            TextareaField,
            SelectField,
            DateField,*/
            SimpleInput
        },
        computed: {
            getWidth() {
                const opt = this.options;
                let width = opt ? opt.width : 100;
                return width ? 'width:' + width + '%' :''
            }
        },
        data() {
            return {
                error: ''
            }
        },
        props: {
            id: String,
            type: String,
            value: undefined,
            options: Object,
            hint: String
        },
        methods: {
            /*inputHandler(e) {
                this.$emit('input', e.target.value)
            }*/
            focusHandler() {
                this.error = '';
                this.$emit('focus');
            },
            invalidHandler(e) {
                console.log(this.value);
                this.error = e;
                this.$emit('invalid', e);
            },
            defineComponent(type) {
                switch(type) {
                    case DATE:
                        return DateField;
                  /*case SELECT:
                        return SelectField;
                    case FILE:
                        return FileField;
                    case RADIO_LIST:
                        return RadioList;
                    case TEXTAREA:
                        return ResizableTextarea;
                    case GROUP:
                        return GroupField;*/
                    default:
                        return SimpleInput
                }
            },


        },
        created() {
            let type = this.type ? this.type : 'text';
            this.component = this.defineComponent(type)
        }

    }
</script>


<style scoped>
    .form-control-v2{
        position: relative;
        z-index: 2;
        display: block;
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        font-size: 16px;
        line-height: 39px;
        color: #333;
        width: 100%;
        height: 40px;
        margin: 0;
        padding: 2px 0 0;
        border: none;
        border-bottom: 1px solid rgba(11, 62, 138, 0.2);;
        border-radius: 0;
        background: #fff;
        -webkit-appearance: none;
        appearance: none;
        outline: none !important;
        text-overflow: ellipsis;
    }

    .form-control-v2:focus, .error-field .form-control-v2:focus, .error-field.on-focus .form-control-v2 {
        border-color: #0fa38e;
    }

    .field-hint {
        font-size: 12px;
        line-height: 18px;
        margin: 1px 0 -2px;
        color: #A6AAB4;
    }

    .field-error {
        font-size: 12px;
        line-height: 18px;
        margin: 1px 0 -2px;
        color: #FF0000;
    }
</style>
